import Color from "./Color";

export const DawnBringerPalette = {
    BLACK_OPACITY: Color.createColor(0x140C1C80),  // 80 alpha instead of FF
    RED_OPACITY: Color.createColor(0xD0464880),
    DARK_GRAY_OPACITY: Color.createColor(0x4E4A4F80),
    DARK_RED_OPACITY: Color.createColor(0x44243480),
    
    BLACK: Color.createColor(0x140C1CFF),
    DARK_RED: Color.createColor(0x442434FF),
    DARK_BLUE: Color.createColor(0x30346DFF),
    DARK_GRAY: Color.createColor(0x4E4A4FFF),
    BROWN: Color.createColor(0x854C30FF),
    DARK_GREEN: Color.createColor(0x346524FF),
    RED: Color.createColor(0xD04648FF),
    LIGHT_GRAY: Color.createColor(0x757161FF),
    LIGHT_BLUE: Color.createColor(0x597DCEFF),
    ORANGE: Color.createColor(0xD27D2CFF),
    BLUE_GRAY: Color.createColor(0x8595A1FF),
    LIGHT_GREEN: Color.createColor(0x6DAA2CFF),
    PEACH: Color.createColor(0xD2AA99FF),
    CYAN: Color.createColor(0x6DC2CAFF),
    YELLOW: Color.createColor(0xDAD45EFF),
    WHITE: Color.createColor(0xDEEED6FF),

};